module.exports = __webpack_public_path__ + "media/icons/gamepad-96e57fa141e36942b6d9321416274b16.svg";